// SEO content for MyCleaner — service pages, local (city) pages and blog.
// All content is Dutch and unique per page.

export const CITIES_META = [
  { slug: "schoonmaker-amsterdam", city: "Amsterdam" },
  { slug: "schoonmaker-haarlem", city: "Haarlem" },
  { slug: "schoonmaker-hoofddorp", city: "Hoofddorp" },
  { slug: "schoonmaker-zaandam", city: "Zaandam" },
  { slug: "schoonmaker-diemen", city: "Diemen" },
  { slug: "schoonmaker-weesp", city: "Weesp" },
  { slug: "schoonmaker-nieuw-vennep", city: "Nieuw-Vennep" },
];

export const SERVICES = {
  "particuliere-schoonmaak": {
    slug: "particuliere-schoonmaak",
    label: "Particuliere schoonmaak",
    seoTitle: "Particuliere schoonmaak | Huishoudelijke hulp | MyCleaner",
    metaDesc:
      "Particuliere schoonmaak door eigen, gescreende schoonmakers. Wekelijks of eenmalig uw woning of appartement laten reinigen. Vraag vrijblijvend een offerte aan.",
    h1: "Particuliere schoonmaak voor uw woning",
    keyword: "particuliere schoonmaak",
    intro:
      "Een schoon huis geeft rust, maar de tijd om alles zelf bij te houden ontbreekt vaak. Met de particuliere schoonmaak van MyCleaner krijgt u een betrouwbare, zorgvuldig gescreende schoonmaker die uw woning of appartement grondig en met aandacht schoonmaakt — wekelijks, om de week of eenmalig.",
    sections: [
      { h2: "Wat houdt huishoudelijke schoonmaak in?", body: [
        "Onze schoonmakers verzorgen het volledige huishouden: stofzuigen en dweilen, badkamer en toilet reinigen, de keuken schoonmaken, afstoffen en waar gewenst bedden verschonen en strijken.",
        "U bepaalt zelf welke werkzaamheden prioriteit hebben. Voor terugkerende afspraken werken we waar mogelijk met een vaste schoonmaker die uw woning en wensen leert kennen.",
      ]},
      { h2: "Voor wie is particuliere schoonmaak geschikt?", body: [
        "Van drukke gezinnen en werkende stellen tot senioren die wat extra hulp kunnen gebruiken: onze huishoudelijke hulp is er voor iedereen die tijd wil overhouden voor de leuke dingen.",
        "Ook voor appartementen, studio's en grotere eengezinswoningen stemmen we de inzet en het aantal uren af op de situatie.",
      ]},
      { h2: "Waarom kiezen voor MyCleaner?", body: [
        "Wij werken met eigen, gescreende schoonmakers en nemen alle benodigde schoonmaakmiddelen mee — u stelt alleen een stofzuiger en dweil beschikbaar. Geen lange contracten, geen verborgen kosten en altijd vooraf een duidelijke prijsopgave.",
      ]},
    ],
    faqs: [
      { q: "Neemt de schoonmaker zelf materialen mee?", a: "Ja, onze schoonmakers nemen alle benodigde schoonmaakmiddelen mee. We vragen u alleen een stofzuiger en dweil beschikbaar te stellen die geschikt zijn voor uw vloeren." },
      { q: "Kan ik wekelijks én eenmalig een afspraak maken?", a: "Zeker. U kunt kiezen voor een eenmalige schoonmaak of een vaste frequentie zoals wekelijks, om de week of maandelijks." },
      { q: "Krijg ik steeds dezelfde schoonmaker?", a: "Waar mogelijk koppelen we u aan een vaste schoonmaker die uw woning kent, zodat u niet elke keer opnieuw hoeft uit te leggen wat u wilt." },
    ],
  },
  "kantoorschoonmaak": {
    slug: "kantoorschoonmaak",
    label: "Kantoorschoonmaak",
    seoTitle: "Kantoorschoonmaak | Zakelijke schoonmaak | MyCleaner",
    metaDesc:
      "Professionele kantoorschoonmaak op vaste of flexibele basis. Een schone, representatieve werkplek voor uw team. Vraag vrijblijvend een offerte aan bij MyCleaner.",
    h1: "Kantoorschoonmaak voor een representatieve werkplek",
    keyword: "kantoorschoonmaak",
    intro:
      "Een schone werkomgeving straalt professionaliteit uit en houdt uw medewerkers gezond en productief. MyCleaner verzorgt de kantoorschoonmaak voor kantoren, praktijken en zakelijke ruimtes — volledig afgestemd op uw planning en buiten kantooruren indien gewenst.",
    sections: [
      { h2: "Zakelijke schoonmaak op maat", body: [
        "Van werkplekken, vergaderruimtes en pantry's tot sanitair en gemeenschappelijke ruimtes: wij stellen samen met u een schoonmaakprogramma op dat past bij de grootte en het gebruik van uw pand.",
        "Schoonmaak kan dagelijks, enkele keren per week of periodiek plaatsvinden, op tijden die uw bedrijfsvoering niet verstoren.",
      ]},
      { h2: "Betrouwbaar en discreet personeel", body: [
        "Onze schoonmakers zijn zorgvuldig gescreend en werken discreet. Voor bedrijven is een vast aanspreekpunt en een vaste schoonmaker extra belangrijk — daar zetten wij graag op in.",
      ]},
      { h2: "Transparante zakelijke tarieven", body: [
        "U ontvangt vooraf een heldere offerte zonder verrassingen. Schoonmaakmiddelen zijn inbegrepen en de planning is flexibel aan te passen aan groei of drukke periodes.",
      ]},
    ],
    faqs: [
      { q: "Kan er buiten kantooruren worden schoongemaakt?", a: "Ja, we plannen de schoonmaak op momenten die u uitkomen, ook 's ochtends vroeg of 's avonds, zodat uw team er geen hinder van ondervindt." },
      { q: "Werken jullie met een vaste schoonmaker voor ons kantoor?", a: "Waar mogelijk koppelen we uw kantoor aan een vaste schoonmaker en een vast aanspreekpunt voor continuïteit en kwaliteit." },
      { q: "Zijn de schoonmaakmiddelen inbegrepen?", a: "Ja, alle benodigde middelen en materialen worden meegenomen en zijn onderdeel van de offerte." },
    ],
  },
  "airbnb-schoonmaak": {
    slug: "airbnb-schoonmaak",
    label: "Airbnb schoonmaak",
    seoTitle: "Airbnb schoonmaak | Wisselschoonmaak vakantieverhuur | MyCleaner",
    metaDesc:
      "Snelle en professionele Airbnb schoonmaak tussen gasten. Altijd een schone, representatieve accommodatie voor de volgende check-in. Vraag een offerte aan.",
    h1: "Airbnb schoonmaak tussen elke gast",
    keyword: "airbnb schoonmaak",
    intro:
      "Positieve reviews beginnen bij een spotless accommodatie. MyCleaner verzorgt de schoonmaak van uw Airbnb of vakantieverhuur tussen verblijven door, zodat uw woning altijd fris en representatief is voor de volgende gasten — ook bij korte wissels op dezelfde dag.",
    sections: [
      { h2: "Snelle wissels zonder stress", body: [
        "Tussen de check-out en check-in verzorgen wij een complete schoonmaak: bedden verschonen, badkamer en keuken reinigen, stofzuigen, dweilen en alles weer gaststatus geven.",
        "Dankzij strakke planning en ervaren schoonmakers zit uw accommodatie op tijd klaar voor de volgende boeking.",
      ]},
      { h2: "Oog voor detail en presentatie", body: [
        "Handdoeken netjes klaarleggen, afval verwijderen en signaleren wanneer voorraden zoals toiletpapier of koffie bijna op zijn — die extra aandacht maakt het verschil in uw reviews.",
      ]},
      { h2: "Voor hosts en beheerders", body: [
        "Of u nu één woning verhuurt of meerdere objecten beheert: wij denken mee over een vaste werkwijze en rapporteren bijzonderheden na elke wissel.",
      ]},
    ],
    faqs: [
      { q: "Kunnen jullie op dezelfde dag tussen gasten schoonmaken?", a: "Ja, we zijn ingericht op snelle wissels en plannen de schoonmaak binnen het tijdvenster tussen check-out en check-in." },
      { q: "Verzorgen jullie ook het linnengoed?", a: "We verschonen de bedden en leggen schone handdoeken klaar. Was- en linnenservice kunnen we in overleg regelen." },
      { q: "Melden jullie schade of ontbrekende voorraden?", a: "Zeker. Na elke wissel signaleren we bijzonderheden en lage voorraden, zodat u tijdig kunt bijvullen." },
    ],
  },
  "dieptereiniging": {
    slug: "dieptereiniging",
    label: "Dieptereiniging",
    seoTitle: "Dieptereiniging | Intensieve schoonmaak & oplevering | MyCleaner",
    metaDesc:
      "Dieptereiniging voor keuken, badkamer en oplevering bij verhuizing. Intensieve schoonmaak van hardnekkig vuil door gescreende schoonmakers. Vraag een offerte aan.",
    h1: "Dieptereiniging: intensieve schoonmaak van top tot teen",
    keyword: "dieptereiniging",
    intro:
      "Sommige klussen vragen meer dan de reguliere schoonmaak. Bij een dieptereiniging pakt MyCleaner het hardnekkige vuil aan dat zich in de loop van de tijd ophoopt — ideaal voor een grote voorjaarsschoonmaak, na een verbouwing of bij de oplevering van een woning.",
    sections: [
      { h2: "Wanneer kiest u voor dieptereiniging?", body: [
        "Denk aan een keuken vol aangekoekt vet, kalkaanslag in de badkamer, kozijnen en plinten die aandacht nodig hebben, of een woning die bij verhuizing bezemschoon tot volledig gereinigd moet worden opgeleverd.",
        "Ook na een verbouwing, waarbij overal fijn stof achterblijft, biedt een dieptereiniging uitkomst.",
      ]},
      { h2: "Wat pakken we extra grondig aan?", body: [
        "We reinigen intensief het sanitair, de keuken inclusief moeilijk bereikbare plekken, tegels, kranen en oppervlakken. Waar nodig gaan we detail voor detail te werk voor een zichtbaar resultaat.",
      ]},
      { h2: "Oplevering bij verhuizing", body: [
        "Verhuist u en moet de woning netjes worden opgeleverd? Wij zorgen dat u uw sleutel met een gerust hart kunt overdragen, volgens de afspraken met verhuurder of makelaar.",
      ]},
    ],
    faqs: [
      { q: "Is een dieptereiniging duurder dan reguliere schoonmaak?", a: "Een dieptereiniging is intensiever en kost daardoor meer tijd. U ontvangt vooraf altijd een duidelijke, vrijblijvende prijsopgave." },
      { q: "Kunnen jullie mijn woning opleveren bij verhuizing?", a: "Ja, we verzorgen opleverschoonmaak zodat de woning volgens afspraak schoon wordt achtergelaten." },
      { q: "Hoe lang duurt een dieptereiniging?", a: "Dat hangt af van de grootte en staat van de woning. Op basis van uw aanvraag maken we een reële inschatting." },
    ],
  },
};

export const SERVICE_ORDER = ["particuliere-schoonmaak", "kantoorschoonmaak", "airbnb-schoonmaak", "dieptereiniging"];

// Unique local angle per city (neighbourhoods / character) used to build unique copy.
export const CITIES = {
  "schoonmaker-amsterdam": {
    city: "Amsterdam",
    seoTitle: "Schoonmaker Amsterdam | Betrouwbare schoonmaak | MyCleaner",
    metaDesc:
      "Op zoek naar een betrouwbare schoonmaker in Amsterdam? MyCleaner regelt gescreende schoonmakers voor woningen, appartementen en kantoren in heel Amsterdam.",
    h1: "Schoonmaker in Amsterdam nodig?",
    intro:
      "In een drukke stad als Amsterdam is tijd kostbaar. Van compacte grachtenappartementen in de Jordaan en De Pijp tot ruimere woningen in Amsterdam-Zuid en Oost: MyCleaner koppelt u aan een betrouwbare, gescreende schoonmaker die de stad kent en flexibel meebeweegt met uw agenda.",
    localBody: [
      "Amsterdamse appartementen vragen om efficiënt en zorgvuldig werk — vaak met beperkte ruimte en steile trappen. Onze schoonmakers zijn dat gewend en werken snel én netjes.",
      "Ook voor kantoren in het centrum en op de Zuidas verzorgen we een representatieve werkplek, buiten kantooruren indien gewenst.",
    ],
  },
  "schoonmaker-haarlem": {
    city: "Haarlem",
    seoTitle: "Schoonmaker Haarlem | Huishoudelijke hulp | MyCleaner",
    metaDesc:
      "Betrouwbare schoonmaker in Haarlem voor woningen, monumentale panden en kantoren. Gescreende schoonmakers, flexibel in te plannen. Vraag een offerte aan.",
    h1: "Uw schoonmaker in Haarlem",
    intro:
      "Haarlem combineert historische, monumentale panden in het centrum met ruime gezinswoningen in wijken als Haarlem-Noord en Schalkwijk. MyCleaner regelt een gescreende schoonmaker die met zorg omgaat met uw woning, of het nu een karakteristiek grachtenpand of een moderne eengezinswoning is.",
    localBody: [
      "Monumentale woningen vragen extra aandacht voor kwetsbare materialen en detaillering. Onze schoonmakers werken hier zorgvuldig mee.",
      "Voor gezinnen in Haarlem-Noord en Schalkwijk bieden we praktische, terugkerende huishoudelijke hulp die tijd bespaart in een druk gezinsleven.",
    ],
  },
  "schoonmaker-hoofddorp": {
    city: "Hoofddorp",
    seoTitle: "Schoonmaker Hoofddorp | Woning & kantoorschoonmaak | MyCleaner",
    metaDesc:
      "Schoonmaker in Hoofddorp voor woningen en kantoren. Van gezinswoningen tot bedrijfspanden op Beukenhorst. Gescreende schoonmakers via MyCleaner.",
    h1: "Schoonmaker in Hoofddorp",
    intro:
      "Hoofddorp is een groeiende gemeente met veel gezinswoningen en een sterk zakelijk hart rond Beukenhorst en Schiphol. MyCleaner biedt zowel huishoudelijke schoonmaak voor gezinnen als professionele kantoorschoonmaak voor de vele bedrijven in de regio Haarlemmermeer.",
    localBody: [
      "In de nieuwbouwwijken van Hoofddorp helpen we gezinnen met terugkerende schoonmaak, zodat er meer tijd overblijft voor het gezin.",
      "Voor kantoren op bedrijventerreinen als Beukenhorst verzorgen we representatieve werkplekken met een flexibele planning.",
    ],
  },
  "schoonmaker-zaandam": {
    city: "Zaandam",
    seoTitle: "Schoonmaker Zaandam | Betrouwbare schoonmaak | MyCleaner",
    metaDesc:
      "Betrouwbare schoonmaker in Zaandam voor woningen en appartementen. Gescreende schoonmakers, flexibel in te plannen. Vraag vrijblijvend een offerte aan.",
    h1: "Schoonmaker in Zaandam",
    intro:
      "Zaandam kent een mix van karakteristieke Zaanse woningen en moderne nieuwbouw rond het vernieuwde stadshart bij het station. MyCleaner regelt een betrouwbare, gescreende schoonmaker die past bij uw woning en uw ritme, van Zaandam-Zuid tot Kogerveld.",
    localBody: [
      "De nieuwe appartementen in het centrum van Zaandam lenen zich uitstekend voor efficiënte, terugkerende schoonmaak.",
      "In de wat oudere wijken bieden we grondige huishoudelijke hulp, afgestemd op het type woning.",
    ],
  },
  "schoonmaker-diemen": {
    city: "Diemen",
    seoTitle: "Schoonmaker Diemen | Huishoudelijke hulp | MyCleaner",
    metaDesc:
      "Schoonmaker in Diemen voor appartementen en woningen. Ideaal voor forenzen die tijd willen besparen. Gescreende schoonmakers via MyCleaner.",
    h1: "Schoonmaker in Diemen",
    intro:
      "Diemen ligt op een steenworp afstand van Amsterdam en is populair bij forenzen en jonge professionals. Met de vele appartementen in Diemen-Zuid en rond het station is er veel vraag naar praktische huishoudelijke hulp — MyCleaner regelt het snel en betrouwbaar.",
    localBody: [
      "Voor drukke forenzen is een vaste schoonmaker goud waard: u komt thuis in een fris huis zonder er zelf tijd aan kwijt te zijn.",
      "Onze schoonmakers werken flexibel rond uw werk- en reistijden.",
    ],
  },
  "schoonmaker-weesp": {
    city: "Weesp",
    seoTitle: "Schoonmaker Weesp | Betrouwbare schoonmaak | MyCleaner",
    metaDesc:
      "Schoonmaker in Weesp voor woningen en monumentale panden in het historische vestingstadje. Gescreende schoonmakers, flexibel in te plannen.",
    h1: "Schoonmaker in Weesp",
    intro:
      "Het historische vestingstadje Weesp, sinds kort onderdeel van Amsterdam, heeft charmante monumentale woningen langs de Vecht en nieuwere wijken daaromheen. MyCleaner biedt een gescreende schoonmaker die met zorg met uw woning omgaat, of die nu historisch of modern is.",
    localBody: [
      "Karakteristieke panden in het centrum van Weesp vragen om zorgvuldige, aandachtige schoonmaak.",
      "Voor gezinnen in de omliggende wijken verzorgen we terugkerende huishoudelijke hulp.",
    ],
  },
  "schoonmaker-nieuw-vennep": {
    city: "Nieuw-Vennep",
    seoTitle: "Schoonmaker Nieuw-Vennep | Huishoudelijke hulp | MyCleaner",
    metaDesc:
      "Schoonmaker in Nieuw-Vennep voor ruime gezinswoningen in o.a. Getsewoud. Gescreende schoonmakers, flexibel in te plannen. Vraag een offerte aan.",
    h1: "Schoonmaker in Nieuw-Vennep",
    intro:
      "Nieuw-Vennep, met ruime gezinswoningen in wijken als Getsewoud, is een fijne woonplaats in de Haarlemmermeer. Grote woningen vragen tijd om schoon te houden — MyCleaner regelt een betrouwbare, gescreende schoonmaker die dat werk uit handen neemt.",
    localBody: [
      "Voor de ruime eengezinswoningen in Getsewoud stemmen we het aantal uren af op de grootte van de woning.",
      "Terugkerende schoonmaak zorgt dat uw woning het hele jaar door fris blijft.",
    ],
  },
};

export const BLOG_ORDER = [
  "wat-kost-een-schoonmaker",
  "hoe-vaak-woning-professioneel-schoonmaken",
  "voordelen-van-een-vaste-schoonmaker",
  "verschil-reguliere-schoonmaak-en-dieptereiniging",
  "airbnb-schoonmaak-gids",
  "woning-voorbereiden-op-schoonmaak",
  "10-tips-woning-langer-schoon-houden",
];

export const BLOG = {
  "wat-kost-een-schoonmaker": {
    slug: "wat-kost-een-schoonmaker",
    seoTitle: "Wat kost een schoonmaker per uur? | Tarieven 2026 | MyCleaner",
    metaDesc: "Wat kost een schoonmaker per uur in Nederland? Ontdek de gemiddelde tarieven voor huishoudelijke hulp, kantoor- en dieptereiniging en waar de prijs van afhangt.",
    h1: "Wat kost een schoonmaker per uur?",
    keyword: "wat kost een schoonmaker",
    excerpt: "Een overzicht van de gemiddelde uurtarieven voor schoonmaak en de factoren die de prijs bepalen.",
    intro: "De kosten van een schoonmaker hangen af van het type werk, de grootte van de locatie en de frequentie. In dit artikel leggen we uit waar u op kunt rekenen en waarom vanaf-tarieven vaak eerlijker zijn dan vaste bedragen.",
    sections: [
      { h2: "Gemiddelde uurtarieven", body: ["Voor particuliere schoonmaak liggen de tarieven doorgaans vanaf €25 per uur. Kantoorschoonmaak start vaak iets lager door de omvang, terwijl dieptereiniging intensiever en dus prijziger is."] },
      { h2: "Welke factoren bepalen de prijs?", body: ["De grootte van de woning, het gewenste resultaat, de frequentie en de bereikbaarheid spelen allemaal mee. Bij een eenmalige of intensieve klus ligt het tarief hoger dan bij terugkerende schoonmaak."] },
      { h2: "Waarom vanaf-tarieven?", body: ["Elke woning is anders. Met een vanaf-prijs en een vrijblijvende offerte weet u vooraf precies waar u aan toe bent, zonder verborgen kosten achteraf."] },
    ],
    related: ["particuliere-schoonmaak", "dieptereiniging"],
  },
  "hoe-vaak-woning-professioneel-schoonmaken": {
    slug: "hoe-vaak-woning-professioneel-schoonmaken",
    seoTitle: "Hoe vaak moet je je woning professioneel laten schoonmaken? | MyCleaner",
    metaDesc: "Wekelijks, om de week of maandelijks? Ontdek hoe vaak u uw woning het beste professioneel kunt laten schoonmaken op basis van uw situatie.",
    h1: "Hoe vaak moet u uw woning professioneel laten schoonmaken?",
    keyword: "hoe vaak woning schoonmaken",
    excerpt: "Wekelijks, om de week of maandelijks — welke frequentie past bij uw huishouden?",
    intro: "Er is geen vast antwoord op hoe vaak schoonmaak nodig is: het hangt af van uw huishouden, huisdieren en levensstijl. We helpen u de juiste frequentie te kiezen.",
    sections: [
      { h2: "Wekelijkse schoonmaak", body: ["Voor drukke gezinnen, huishoudens met huisdieren of wie simpelweg altijd een fris huis wil, is wekelijkse schoonmaak ideaal."] },
      { h2: "Om de week of maandelijks", body: ["Kleinere huishoudens of stellen kiezen vaak voor schoonmaak om de week. Maandelijks werkt goed als aanvulling op wat u zelf bijhoudt."] },
      { h2: "Combineren met dieptereiniging", body: ["Een periodieke dieptereiniging, bijvoorbeeld per kwartaal, houdt ook de moeilijke plekken langdurig schoon."] },
    ],
    related: ["particuliere-schoonmaak", "dieptereiniging"],
  },
  "voordelen-van-een-vaste-schoonmaker": {
    slug: "voordelen-van-een-vaste-schoonmaker",
    seoTitle: "De voordelen van een vaste schoonmaker | MyCleaner",
    metaDesc: "Een vaste schoonmaker kent uw woning en wensen. Ontdek de voordelen van vertrouwdheid, consistentie en gemak met een vaste schoonmaker van MyCleaner.",
    h1: "De voordelen van een vaste schoonmaker",
    keyword: "vaste schoonmaker",
    excerpt: "Waarom vertrouwdheid en consistentie het verschil maken bij schoonmaak.",
    intro: "Een vaste schoonmaker biedt meer dan gemak. Vertrouwen, consistentie en persoonlijke aandacht zorgen voor een beter en prettiger resultaat.",
    sections: [
      { h2: "Vertrouwen en veiligheid", body: ["U laat iemand in uw huis. Een vaste, gescreende schoonmaker die u leert kennen geeft rust en vertrouwen."] },
      { h2: "Consistente kwaliteit", body: ["Iemand die uw woning kent, weet precies waar de aandacht naartoe moet en levert keer op keer hetzelfde hoge niveau."] },
      { h2: "Minder uitleg, meer gemak", body: ["U hoeft niet elke keer opnieuw uw wensen door te nemen. Dat scheelt tijd en voorkomt misverstanden."] },
    ],
    related: ["particuliere-schoonmaak", "kantoorschoonmaak"],
  },
  "verschil-reguliere-schoonmaak-en-dieptereiniging": {
    slug: "verschil-reguliere-schoonmaak-en-dieptereiniging",
    seoTitle: "Verschil tussen reguliere schoonmaak en dieptereiniging | MyCleaner",
    metaDesc: "Wat is het verschil tussen gewone schoonmaak en een dieptereiniging? Ontdek wanneer u welke schoonmaak nodig heeft voor het beste resultaat.",
    h1: "Het verschil tussen reguliere schoonmaak en dieptereiniging",
    keyword: "verschil schoonmaak dieptereiniging",
    excerpt: "Wanneer volstaat gewone schoonmaak en wanneer is een dieptereiniging nodig?",
    intro: "Reguliere schoonmaak en dieptereiniging vullen elkaar aan. Het verschil zit in de intensiteit en de plekken die worden aangepakt.",
    sections: [
      { h2: "Reguliere schoonmaak", body: ["Dit is het onderhoud dat uw woning fris houdt: stofzuigen, dweilen, sanitair en keuken bijhouden. Ideaal op terugkerende basis."] },
      { h2: "Dieptereiniging", body: ["Hierbij pakken we hardnekkig vuil aan: aangekoekt vet, kalkaanslag, kozijnen, plinten en moeilijk bereikbare plekken. Perfect voor een grote beurt of oplevering."] },
      { h2: "Wat heeft u nodig?", body: ["Houdt u de boel regelmatig bij, dan volstaat reguliere schoonmaak. Na een verbouwing, verhuizing of langere tijd is een dieptereiniging aan te raden."] },
    ],
    related: ["dieptereiniging", "particuliere-schoonmaak"],
  },
  "airbnb-schoonmaak-gids": {
    slug: "airbnb-schoonmaak-gids",
    seoTitle: "Airbnb schoonmaak: alles wat u moet weten | MyCleaner",
    metaDesc: "Alles over Airbnb schoonmaak: wisselschoonmaak, timing, linnengoed en 5-sterren reviews. De complete gids voor hosts en beheerders van vakantieverhuur.",
    h1: "Airbnb schoonmaak: alles wat u moet weten",
    keyword: "airbnb schoonmaak",
    excerpt: "De complete gids voor een spotless accommodatie en betere reviews.",
    intro: "Schone accommodaties krijgen betere reviews en meer boekingen. In deze gids leest u hoe professionele Airbnb schoonmaak werkt en waar u op moet letten.",
    sections: [
      { h2: "Waarom schoonmaak cruciaal is", body: ["Netheid is een van de belangrijkste beoordelingscriteria op Airbnb. Eén slechte review over hygiëne kan uw boekingen flink beïnvloeden."] },
      { h2: "De wisselschoonmaak", body: ["Tussen check-out en check-in moet alles weer gaststatus krijgen: bedden verschonen, sanitair en keuken reinigen en netjes presenteren."] },
      { h2: "Voorraden en signalering", body: ["Een goede schoonmaker signaleert lage voorraden en schade, zodat u tijdig kunt ingrijpen en verrassingen voorkomt."] },
    ],
    related: ["airbnb-schoonmaak", "dieptereiniging"],
  },
  "woning-voorbereiden-op-schoonmaak": {
    slug: "woning-voorbereiden-op-schoonmaak",
    seoTitle: "Hoe bereidt u uw woning voor op een professionele schoonmaak? | MyCleaner",
    metaDesc: "Praktische tips om uw woning voor te bereiden op de komst van een schoonmaker, zodat de tijd optimaal wordt benut en het resultaat maximaal is.",
    h1: "Hoe bereidt u uw woning voor op een professionele schoonmaak?",
    keyword: "woning voorbereiden schoonmaak",
    excerpt: "Met een korte voorbereiding haalt u het meeste uit uw schoonmaakafspraak.",
    intro: "Een paar simpele voorbereidingen zorgen dat uw schoonmaker de tijd optimaal besteedt aan écht schoonmaken in plaats van opruimen.",
    sections: [
      { h2: "Ruim losse spullen op", body: ["Leg persoonlijke spullen en rondslingerende items even weg, zodat oppervlakken vrij zijn om te reinigen."] },
      { h2: "Communiceer uw prioriteiten", body: ["Geef aan welke ruimtes of taken voorrang hebben. Zo weet de schoonmaker waar de aandacht naartoe moet."] },
      { h2: "Zorg voor toegang en materialen", body: ["Zorg dat de woning toegankelijk is en dat een stofzuiger en dweil beschikbaar zijn die geschikt zijn voor uw vloeren."] },
    ],
    related: ["particuliere-schoonmaak"],
  },
  "10-tips-woning-langer-schoon-houden": {
    slug: "10-tips-woning-langer-schoon-houden",
    seoTitle: "10 tips om uw woning langer schoon te houden | MyCleaner",
    metaDesc: "10 praktische tips om uw woning tussen schoonmaakbeurten door langer fris en schoon te houden. Simpele gewoontes met groot effect.",
    h1: "10 tips om uw woning langer schoon te houden",
    keyword: "woning langer schoon houden",
    excerpt: "Simpele dagelijkse gewoontes die uw woning langer fris houden.",
    intro: "Met een paar slimme gewoontes houdt u uw woning tussen de schoonmaakbeurten door langer fris. Deze tien tips helpen u op weg.",
    sections: [
      { h2: "Kleine dagelijkse gewoontes", body: ["Ruim direct op na gebruik, veeg de keuken na het koken schoon en maak uw bed elke ochtend op. Kleine acties voorkomen grote klussen."] },
      { h2: "Voorkom vuil aan de bron", body: ["Gebruik een deurmat, laat schoenen bij de deur en ventileer dagelijks om vocht en stof te beperken."] },
      { h2: "Werk met een ritme", body: ["Verdeel taken over de week in plaats van alles op één dag. Een vaste schoonmaker helpt dat ritme moeiteloos vol te houden."] },
    ],
    related: ["particuliere-schoonmaak"],
  },
};
